/* ---------------------------------------------------------------
	READY
 --------------------------------------------------------------- */
$(document).ready(function () {
	//console.log("init CONTACT")

	// Repertoire Ajax
	let urlAjaxProspect = "/contact/ajax/prospect/";
	let urlAjaxVille = "/admin/ajax/ville/";

	// Supprime le cadre lors du click sur un lien
	$("a").focus(function () {
		$("a").blur();
	});

	/* ---------------------------------------------------------------
	VALIDATION DES FORMULAIRES
 --------------------------------------------------------------- */
	$.validator.setDefaults({
		debug: true,
		ignore: "input[autocomplete=off],:disabled, .note-codable, :hidden:not(#summernote), .note-editable.panel-body",
		errorElement: "span",
		errorClass: "help-block",
		highlight: function (element, errorClass, validClass) {
			$(element).closest(".form-group").addClass("has-error");
		},
		unhighlight: function (element, errorClass, validClass) {
			$(element).closest(".form-group").removeClass("has-error");
		},
		errorPlacement: function (error, element) {
			if (
				element.parent(".input-group").length ||
				element.prop("type") === "checkbox" ||
				element.prop("type") === "radio"
			) {
				error.insertAfter(element.parent());
			} else {
				error.insertAfter(element);
			}
		},
	});

	// Summernote
	if ($(".summernote").length > 0) {
		$(".summernote").summernote({
			height: 100,
			toolbar: [
				["style", ["bold", "italic", "underline", "strikethrough", "clear"]],
				["color", ["color"]],
			],
		});
		$(".note-btn").removeAttr("title");
	}

	// Lada
	if ($("form button[type=submit]").length > 0) {
		let ladForm = $("form button[type=submit]").ladda();
	}

	if ($("#fml_prospect").length > 0) {
		let formId = "#fml_prospect";
		let origine = Number($("#fml_prospect input[name=origine_id]").val());
		$(formId).validate({
			submitHandler: function (form) {
				var options = {
					url: urlAjaxProspect + "ins.php",
					type: "POST",
					dataType: "json",
					beforeSubmit: function () {
						$("form button[type=submit]").ladda("start");
					},
					success: function (e) {
						console.log(e);
						$("form button[type=submit]").remove();
						$("#msg_alert").fadeIn();
						setTimeout(function () {
							if (origine == 22) {
								//top.location.href="autrepage.htm"
								top.location.href =
									"https://www.neo-forma.fr/demande-devis-neo-forma.html";
							} else if (origine == 23) {
								//top.location.href="autrepage.htm"
								top.location.href =
									"https://www.osteoentreprise.com/demande-de-devis-osteo-entreprise.html";
							}
						}, 1000);
					},
				};
				$(formId).ajaxSubmit(options);
				return false;
			},
		});
	}

	// Adresse
	if ($(".form_adresse").length > 0) {
		//console.log("adresse")

		// Display Cedex
		$("input[name=is_cedex]").change(function () {
			var isCedex = $(this).val();
			if (isCedex == 1) {
				$("#form_cp").hide();
				$("#form_cedex").fadeIn();
			} else {
				$("#form_cedex").hide();
				$("#form_cp").fadeIn();
			}
		});

		// Recherche Ville
		let myAjaxVilleRechercher = $.ajax();
		$("input[name=cp]").keyup(function () {
			myAjaxVilleRechercher.abort();
			var recherche = $(this).val();

			myAjaxVilleRechercher = $.ajax({
				url: urlAjaxVille + "liste.php",
				data: "recherche=" + recherche,
				type: "POST",
				success: function (retour) {
					$("select[name=ville_id]").html(retour);
				},
				complete: function () {
					$("select[name=ville_id]").selectpicker("refresh");
				},
			});
		});
	}
	if ($(".form_ville").length > 0) {
		console.log("adresse");

		// Recherche Ville
		myAjaxVilleRechercher = $.ajax();
		$("input[name=cp]").keyup(function () {
			myAjaxVilleRechercher.abort();
			var recherche = $(this).val();

			myAjaxVilleRechercher = $.ajax({
				url: urlAjaxVille + "liste.php",
				data: "recherche=" + recherche,
				type: "POST",
				success: function (retour) {
					$("select[name=ville_id]").html(retour);
				},
				complete: function () {
					$("select[name=ville_id]").selectpicker("refresh");
				},
			});
		});
	}
});
/* ---------------------------------------------------------------
	END
 --------------------------------------------------------------- */
